import styled from "styled-components";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import CustomButton from "../../../helperComponents/CustomButton";
import { BiCalendar, BiExport, BiUser } from "react-icons/bi";
import { GrDisabledOutline } from "react-icons/gr";
import { TbBeach } from "react-icons/tb";
import { GoIssueOpened } from "react-icons/go";
import { useEffect, useState } from "react";
import { serverLine } from "../../../../controllers/network/serverLine";
import CustomPagination from "../../../helperComponents/CustomPagination";
import CustomMasonry from "../../../helperComponents/CustomMasonry";
import EmployeeCard from "../employees/EmployeeCard";
import LoadingSection from "../../../helperComponents/LoadingSection";
import ListSizeSetter from "../../../helperComponents/ListSizeSetter";
import ListPage from "../../../customUiForCs/ListPage";
import goTo from "../../../../controllers/goTo";
import exportFunction from "../../../../controllers/customControllerForCS/exportFunction";
import DropDownInput from "../../../helperComponents/DropDownInput";
import employeeTypes from "../../../../data/employee/employeeTypes";
import NomenclatureOfEmployee from "../nomenclature/NomenclatureOfEmployee";
import NomenclatureOfAbsence from "../nomenclature/NomenclatureOfAbsence";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 30px;
  width: 100%;
  margin-top: 30px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Content = styled.div`
  padding: 15px;
  border: 1px solid var(--borderDim);
  background: var(--gradientSurface);
  border-radius: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const BottomPart = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

let columns = [
  "Zone Name",
  "Site Place Name",
  //
  "Profile First Name",
  // "Site Codename",
  "Profile Last Name",

  "Profile Registration Number",
  "Start Date",

  "End Date",
];

export default function AbsenceListPage() {
  return (
    <LoggedInBoilerplate titleLine1={"Liste des"} titleLine2={"Absences"}>
      <NomenclatureOfAbsence tableViewSettings={{ columns }} columns={2} />
    </LoggedInBoilerplate>
  );
}
